import { useStaticQuery, graphql } from "gatsby";
import kebabCase from "lodash/kebabCase";

type Category = {
  label: string;
  path: string;
};

export const useCategories = (): Category[] => {
  // Get all markdown categories
  const { allMdx } = useStaticQuery(
    graphql`
      {
        allMdx {
          group(field: frontmatter___category) {
            fieldValue
          }
        }
      }
    `
  );

  return allMdx.group.map(({ fieldValue }: { fieldValue: string }) => ({
    label: fieldValue,
    path: kebabCase(fieldValue),
  }));
};
